import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import ScrollToTop from '@/components/ScrollToTop';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import EmployeeDashboard from '@/pages/EmployeeDashboard';
import EmployeeDashboardPage from '@/pages/EmployeeDashboardPage';
import ChecklistPage from '@/pages/ChecklistPage';
import DelegationPage from '@/pages/DelegationPage';
import FMSPage from '@/pages/FMSPage';
import FMSFlowchartEditor from '@/pages/FMSFlowchartEditor';
import ItemMasterPage from '@/pages/ItemMasterPage';
import SubLocationsPage from '@/pages/SubLocationsPage';
import UOMMasterPage from '@/pages/UOMMasterPage';
import SalesOrderPage from '@/pages/SalesOrderPage';
import WorkOrderPage from '@/pages/WorkOrderPage';
import WorkOrderDetailPage from '@/pages/WorkOrderDetailPage';
import ClientMasterPage from '@/pages/ClientMasterPage';
import ProcessMasterPage from '@/pages/ProcessMasterPage';
import BOMMasterPage from '@/pages/BOMMasterPage';
import VariantGroupPage from '@/pages/VariantGroupPage';
import ProductionPlanningPage from '@/pages/ProductionPlanningPage';
import SupplierMasterPage from '@/pages/SupplierMasterPage';
import IndentRegisterPage from '@/pages/IndentRegisterPage';
import PurchaseOrdersPage from '@/pages/PurchaseOrdersPage';
import UserManagementPage from '@/pages/UserManagementPage';
import MyTasksPage from '@/pages/MyTasksPage';
import MyRequestsPage from '@/pages/MyRequestsPage';
import EmployeeRequestsRegisterPage from '@/pages/EmployeeRequestsRegisterPage';
import StockAdjustmentsRegisterPage from '@/pages/StockAdjustmentsRegisterPage';
import EmployeeMasterPage from '@/pages/EmployeeMasterPage';
import DesignationMasterPage from '@/pages/DesignationMasterPage';
import HolidayMasterPage from '@/pages/HolidayMasterPage';
import MISDashboardPage from '@/pages/MISDashboardPage';
import GateEntryPublicPage from '@/pages/GateEntryPublicPage';
import GateEntryRegisterPublicPage from '@/pages/GateEntryRegisterPublicPage';
import SecurityCheckinPage from '@/pages/SecurityCheckinPage';
import SecurityCheckinDashboard from '@/pages/SecurityCheckinDashboard';
import SecurityGatePassPage from '@/pages/SecurityGatePassPage';
import EmployeeMovementPage from '@/pages/EmployeeMovementPage';
import EmployeeMovementReportPage from '@/pages/EmployeeMovementReportPage';
import GateEntryPage from '@/pages/GateEntryPage';
import GateEntryRegisterPage from '@/pages/GateEntryRegisterPage';
import GatePassSecurityPage from '@/pages/GatePassSecurityPage';
import CreateGatePassPage from '@/pages/CreateGatePassPage';
import DCRegisterPage from '@/pages/DCRegisterPage';
import CreateDCPage from '@/pages/CreateDCPage';
import DebitNoteRegisterPage from '@/pages/DebitNoteRegisterPage';
import LoadingConsolePage from '@/pages/LoadingConsolePage';
import StoreReceivingPage from '@/pages/StoreReceivingPage';
import PurchaseEntryPage from '@/pages/PurchaseEntryPage';
import InvoiceReportPage from '@/pages/InvoiceReportPage';
import OJCRegisterPage from '@/pages/OJCRegisterPage';
import SampleRegisterPage from '@/pages/SampleRegisterPage';
import DataBackupPage from '@/pages/DataBackupPage';
import FYMigrationPage from '@/pages/FYMigrationPage';
import FMSTrackingReportPage from '@/pages/FMSTrackingReportPage';
import ItemNettStatusPage from '@/pages/ItemNettStatusPage';
import BatchStockLedgerPage from '@/pages/BatchStockLedgerPage';
import LocationMasterPage from '@/pages/LocationMasterPage';
import InterUnitTransferPage from '@/pages/InterUnitTransferPage';
import FulfillmentTasksPage from '@/pages/FulfillmentTasksPage';
import ProjectsPage from '@/pages/ProjectsPage';
import InventoryReportPage from '@/pages/InventoryReportPage';
import SOFulfillmentPage from '@/pages/SOFulfillmentPage';
import ClientLedgerPage from '@/pages/ClientLedgerPage';
import CTMIssuancePage from '@/pages/CTMIssuancePage';
import MaterialAgingPage from '@/pages/MaterialAgingPage';
import ProcurementTrackingPage from '@/pages/ProcurementTrackingPage';
import PODiscrepancyPage from '@/pages/PODiscrepancyPage';
import ComplaintsPage from '@/pages/ComplaintsPage';
import WorkerProductivityReportPage from '@/pages/WorkerProductivityReportPage';
import PooledJobsPage from '@/pages/PooledJobsPage';
import AnnouncementsPage from '@/pages/AnnouncementsPage';
import BulkUploadPage from '@/pages/BulkUploadPage';
import PendingBOMPage from '@/pages/PendingBOMPage';
import SOViewOnlyPage from '@/pages/SOViewOnlyPage';
import WOViewOnlyPage from '@/pages/WOViewOnlyPage';
import VariantsPendingPage from '@/pages/VariantsPendingPage';
import ProductionFulfillmentPage from '@/pages/ProductionFulfillmentPage';
import PurchaseFulfillmentPage from '@/pages/PurchaseFulfillmentPage';
import BinCardPage from '@/pages/BinCardPage';
import DoneTasksReportPage from '@/pages/DoneTasksReportPage';
import StorePendingIssuesPage from '@/pages/StorePendingIssuesPage';
import MigrationReportPage from '@/pages/MigrationReportPage';
import CreateIndentPage from '@/pages/CreateIndentPage';
import DocumentationPage from '@/pages/DocumentationPage';
import AuditLogsPage from '@/pages/AuditLogsPage';
import VarianceAuditPage from '@/pages/VarianceAuditPage';
import LocationTeamMappingPage from '@/pages/LocationTeamMappingPage';
import SWSWorkflowsPage from '@/pages/SWSWorkflowsPage';
import SWSWorkflowBuilderPage from '@/pages/SWSWorkflowBuilderPage';
import SWSTasksRegisterPage from '@/pages/SWSTasksRegisterPage';
import ItemCodeRequestPage from '@/pages/ItemCodeRequestPage';
import ItemCodeRequestsRegisterPage from '@/pages/ItemCodeRequestsRegisterPage';
import MISScoringDocPage from '@/pages/MISScoringDocPage';
import ItemCodeConstructorPage from '@/pages/ItemCodeConstructorPage';
import ItemCodeManagerPage from '@/pages/ItemCodeManagerPage';
import GRNDocumentsPage from '@/pages/GRNDocumentsPage';
import GRNRegisterPage from '@/pages/GRNRegisterPage';
import PaymentRequestsPage from '@/pages/PaymentRequestsPage';
import PaymentApprovalsPage from '@/pages/PaymentApprovalsPage';
import AccountsPaymentsPage from '@/pages/AccountsPaymentsPage';
import SupplierLedgerPage from '@/pages/SupplierLedgerPage';
import ServicePurchaseOrdersPage from '@/pages/ServicePurchaseOrdersPage';
import ServicesReceivedNotesPage from '@/pages/ServicesReceivedNotesPage';
import ExcelMergePage from '@/pages/ExcelMergePage';
import BankTransactionsPage from '@/pages/BankTransactionsPage';
import JournalEntriesPage from '@/pages/JournalEntriesPage';
import SalesReceiptsPage from '@/pages/SalesReceiptsPage';
import GPAnalyticsPage from '@/pages/GPAnalyticsPage';
import AssetRegisterPage from '@/pages/AssetRegisterPage';
import PurchaseDashboardPage from '@/pages/PurchaseDashboardPage';
import PurchaseReportsPage from '@/pages/PurchaseReportsPage';
import MaterialVariancePage from '@/pages/MaterialVariancePage';
import ServiceProviderMasterPage from '@/pages/ServiceProviderMasterPage';
import ForexPaymentsPage from '@/pages/ForexPaymentsPage';
import ImportShipmentsPage from '@/pages/ImportShipmentsPage';
import DownloadsPage from '@/pages/DownloadsPage';
import FulfillmentDashboardPage from '@/pages/FulfillmentDashboardPage';
import ProductionFulfillmentNewPage from '@/pages/ProductionFulfillmentNewPage';
import PurchaseFulfillmentNewPage from '@/pages/PurchaseFulfillmentNewPage';
import PurchaseReturnsPage from '@/pages/PurchaseReturnsPage';
import MaintenancePage from '@/pages/MaintenancePage';
import MaintenanceModePage from '@/pages/MaintenanceModePage';
import OTPermissionPage from '@/pages/OTPermissionPage';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import '@/App.css';

const ProtectedRoute = ({ children, requiredModule }) => {
  const { user, loading, maintenanceMode } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Maintenance mode: user logged in but not exempt — owners always bypass
  if (maintenanceMode && !user.is_owner) return <MaintenancePage />;

  // Check module access if requiredModule is specified
  if (requiredModule && !user.is_owner) {
    const allowedModules = user.allowed_modules || [];
    if (allowedModules.length > 0 && !allowedModules.includes(requiredModule)) {
      // Redirect to home (which will show appropriate dashboard)
      return <Navigate to="/" replace />;
    }
  }
  
  return children;
};

// Smart Dashboard component that shows appropriate dashboard based on user type
const SmartDashboard = () => {
  const { user } = useAuth();
  
  // All non-owners see Employee Dashboard, owners see Owner Dashboard
  if (!user?.is_owner) {
    return <EmployeeDashboard />;
  }
  
  return <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <SmartDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-dashboard"
            element={
              <ProtectedRoute>
                <EmployeeDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checklists"
            element={
              <ProtectedRoute requiredModule="checklists">
                <ChecklistPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/delegation-tasks"
            element={
              <ProtectedRoute requiredModule="delegation">
                <DelegationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-tasks"
            element={
              <ProtectedRoute requiredModule="my_tasks">
                <MyTasksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-requests"
            element={
              <ProtectedRoute>
                <MyRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/employee-requests-register"
            element={
              <ProtectedRoute>
                <EmployeeRequestsRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/stock-adjustments-register"
            element={
              <ProtectedRoute>
                <StockAdjustmentsRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fms"
            element={
              <ProtectedRoute requiredModule="fms">
                <FMSPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fms/flowchart/:id"
            element={
              <ProtectedRoute>
                <FMSFlowchartEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/items"
            element={
              <ProtectedRoute>
                <ItemMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/assets"
            element={
              <ProtectedRoute>
                <AssetRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/uom"
            element={
              <ProtectedRoute>
                <UOMMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/sub-locations"
            element={
              <ProtectedRoute>
                <SubLocationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/report"
            element={
              <ProtectedRoute>
                <InventoryReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/so-fulfillment"
            element={
              <ProtectedRoute>
                <SOFulfillmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/client-ledger"
            element={
              <ProtectedRoute>
                <ClientLedgerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/receipts"
            element={
              <ProtectedRoute>
                <SalesReceiptsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/item-status"
            element={
              <ProtectedRoute>
                <ItemNettStatusPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/batch-ledger"
            element={
              <ProtectedRoute>
                <BatchStockLedgerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/sales-orders"
            element={
              <ProtectedRoute>
                <SalesOrderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/pending-bom"
            element={
              <ProtectedRoute>
                <PendingBOMPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/so-view/:soId"
            element={
              <ProtectedRoute>
                <SOViewOnlyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/work-orders/view/:woId"
            element={
              <ProtectedRoute>
                <WOViewOnlyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/variants-pending"
            element={
              <ProtectedRoute>
                <VariantsPendingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/fulfillment"
            element={
              <ProtectedRoute>
                <ProductionFulfillmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/fulfillment"
            element={
              <ProtectedRoute>
                <PurchaseFulfillmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/fms-tracking"
            element={
              <ProtectedRoute>
                <FMSTrackingReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/loading-console"
            element={
              <ProtectedRoute>
                <LoadingConsolePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/work-orders"
            element={
              <ProtectedRoute>
                <WorkOrderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/work-orders/:woId"
            element={
              <ProtectedRoute>
                <WorkOrderDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/pooled-jobs"
            element={
              <ProtectedRoute>
                <PooledJobsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/ot-permission"
            element={
              <ProtectedRoute requiredModule="ot_permissions">
                <OTPermissionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/clients"
            element={
              <ProtectedRoute>
                <ClientMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/projects"
            element={
              <ProtectedRoute>
                <ProjectsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/processes"
            element={
              <ProtectedRoute>
                <ProcessMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/bom"
            element={
              <ProtectedRoute>
                <BOMMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/variant-groups"
            element={
              <ProtectedRoute>
                <VariantGroupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/planning"
            element={
              <ProtectedRoute>
                <ProductionPlanningPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/suppliers"
            element={
              <ProtectedRoute>
                <SupplierMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/indents"
            element={
              <ProtectedRoute>
                <IndentRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/create-indent"
            element={
              <ProtectedRoute requiredModule="create_indent">
                <CreateIndentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/orders"
            element={
              <ProtectedRoute>
                <PurchaseOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/service-po"
            element={
              <ProtectedRoute>
                <ServicePurchaseOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/srn"
            element={
              <ProtectedRoute>
                <ServicesReceivedNotesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/invoice-report"
            element={
              <ProtectedRoute>
                <InvoiceReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/backup"
            element={
              <ProtectedRoute>
                <DataBackupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/migration"
            element={
              <ProtectedRoute>
                <FYMigrationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/audit-logs"
            element={
              <ProtectedRoute>
                <AuditLogsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/variance-audit"
            element={
              <ProtectedRoute>
                <VarianceAuditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/location-team-mapping"
            element={
              <ProtectedRoute>
                <LocationTeamMappingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/sws"
            element={
              <ProtectedRoute>
                <SWSWorkflowsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sws/tasks-register"
            element={
              <ProtectedRoute>
                <SWSTasksRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/sws/builder"
            element={
              <ProtectedRoute>
                <SWSWorkflowBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/sws/builder/:workflowId"
            element={
              <ProtectedRoute>
                <SWSWorkflowBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/utilities/item-code-request"
            element={
              <ProtectedRoute>
                <ItemCodeRequestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/utilities/item-code-requests-register"
            element={
              <ProtectedRoute>
                <ItemCodeRequestsRegisterPage />
              </ProtectedRoute>
            }
          />
          {/* Item Code Generator - 2 Consolidated Pages */}
          <Route
            path="/admin/item-code-constructor"
            element={
              <ProtectedRoute>
                <ItemCodeConstructorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/utilities/item-code-manager"
            element={
              <ProtectedRoute>
                <ItemCodeManagerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/employees"
            element={
              <ProtectedRoute>
                <EmployeeMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/designations"
            element={
              <ProtectedRoute>
                <DesignationMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/holidays"
            element={
              <ProtectedRoute>
                <HolidayMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mis"
            element={
              <ProtectedRoute requiredModule="mis_dashboard">
                <MISDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/worker-productivity"
            element={
              <ProtectedRoute>
                <WorkerProductivityReportPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Public Gate Entry (No Auth - Legacy) */}
          <Route path="/gate-entry" element={<GateEntryPublicPage />} />
          {/* Security Check-in (No Auth - Public) */}
          <Route path="/security-checkin" element={<SecurityCheckinPage />} />
          {/* Legacy route - redirect to new URL */}
          <Route path="/gate-entry/security-checkin" element={<SecurityCheckinPage />} />
          {/* Public Gate Entry Register (No Auth - for Security) */}
          <Route path="/gate-entry/register" element={<GateEntryRegisterPublicPage />} />
          {/* Security Gate Pass OUT (No Auth - Public) */}
          <Route path="/security/gate-pass" element={<SecurityGatePassPage />} />
          {/* Employee Movement Tracking (No Auth - Public) */}
          <Route path="/security/employee-movement" element={<EmployeeMovementPage />} />
          {/* Migration Report - Public (No Auth) */}
          <Route path="/migration-report" element={<MigrationReportPage />} />
          {/* Documentation Page */}
          <Route
            path="/utilities/documentation"
            element={
              <ProtectedRoute>
                <DocumentationPage />
              </ProtectedRoute>
            }
          />
          {/* MIS Scoring Logic Documentation */}
          <Route
            path="/utilities/mis-scoring-docs"
            element={
              <ProtectedRoute>
                <MISScoringDocPage />
              </ProtectedRoute>
            }
          />
          {/* Security Check-in Dashboard */}
          <Route
            path="/utilities/security-checkins"
            element={
              <ProtectedRoute>
                <SecurityCheckinDashboard />
              </ProtectedRoute>
            }
          />
          {/* Employee Movement Report */}
          <Route
            path="/utilities/employee-movements"
            element={
              <ProtectedRoute>
                <EmployeeMovementReportPage />
              </ProtectedRoute>
            }
          />
          {/* Excel Data Merge Tool */}
          <Route
            path="/utilities/excel-merge"
            element={
              <ProtectedRoute>
                <ExcelMergePage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Authenticated Gate Entry (For Security Personnel) */}
          <Route
            path="/store/gate-entry"
            element={
              <ProtectedRoute>
                <GateEntryPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Gate Entry Register */}
          <Route
            path="/store/gate-entry-register"
            element={
              <ProtectedRoute>
                <GateEntryRegisterPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Gate Pass Security Dashboard */}
          <Route
            path="/store/gate-pass"
            element={
              <ProtectedRoute>
                <GatePassSecurityPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Create Gate Pass */}
          <Route
            path="/store/gate-pass/create"
            element={
              <ProtectedRoute>
                <CreateGatePassPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Delivery Challan Register */}
          <Route
            path="/store/dc"
            element={
              <ProtectedRoute>
                <DCRegisterPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Create Delivery Challan */}
          <Route
            path="/store/dc/create"
            element={
              <ProtectedRoute>
                <CreateDCPage />
              </ProtectedRoute>
            }
          />
          {/* Finance Module - Debit Note Register */}
          <Route
            path="/finance/debit-notes"
            element={
              <ProtectedRoute>
                <DebitNoteRegisterPage />
              </ProtectedRoute>
            }
          />
          {/* Accounts Module - GRN Documents */}
          <Route
            path="/accounts/grn-documents"
            element={
              <ProtectedRoute>
                <GRNDocumentsPage />
              </ProtectedRoute>
            }
          />
          {/* GRN Register */}
          <Route
            path="/purchase/grn-register"
            element={
              <ProtectedRoute>
                <GRNRegisterPage />
              </ProtectedRoute>
            }
          />
          {/* Payment Requests Module */}
          <Route
            path="/purchase/payment-requests"
            element={
              <ProtectedRoute>
                <PaymentRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/dashboard"
            element={
              <ProtectedRoute>
                <PurchaseDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/reports"
            element={
              <ProtectedRoute>
                <PurchaseReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/purchase-returns"
            element={
              <ProtectedRoute>
                <PurchaseReturnsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/service-providers"
            element={
              <ProtectedRoute>
                <ServiceProviderMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/forex-payments"
            element={
              <ProtectedRoute>
                <ForexPaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/import-shipments"
            element={
              <ProtectedRoute>
                <ImportShipmentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/downloads"
            element={
              <ProtectedRoute requiredModule="downloads">
                <DownloadsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/payment-approvals"
            element={
              <ProtectedRoute>
                <PaymentApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/payments"
            element={
              <ProtectedRoute>
                <AccountsPaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/supplier-ledger"
            element={
              <ProtectedRoute>
                <SupplierLedgerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/bank-transactions"
            element={
              <ProtectedRoute>
                <BankTransactionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/journal-entries"
            element={
              <ProtectedRoute>
                <JournalEntriesPage />
              </ProtectedRoute>
            }
          />
          {/* Store Module - Protected Routes */}
          <Route
            path="/store/receiving"
            element={
              <ProtectedRoute>
                <StoreReceivingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/purchase-entry"
            element={
              <ProtectedRoute>
                <PurchaseEntryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/ojc-register"
            element={
              <ProtectedRoute>
                <OJCRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/samples"
            element={
              <ProtectedRoute>
                <SampleRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/locations"
            element={
              <ProtectedRoute>
                <LocationMasterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/inter-unit-transfers"
            element={
              <ProtectedRoute>
                <InterUnitTransferPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/fulfillment-tasks"
            element={
              <ProtectedRoute>
                <FulfillmentTasksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/ctm-issuance"
            element={
              <ProtectedRoute>
                <CTMIssuancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/bin-card"
            element={
              <ProtectedRoute>
                <BinCardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/pending-issues"
            element={
              <ProtectedRoute>
                <StorePendingIssuesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/material-aging"
            element={
              <ProtectedRoute>
                <MaterialAgingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/procurement-tracking"
            element={
              <ProtectedRoute>
                <ProcurementTrackingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/material-variance"
            element={
              <ProtectedRoute>
                <MaterialVariancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/gp-analytics"
            element={
              <ProtectedRoute>
                <GPAnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/discrepancies"
            element={
              <ProtectedRoute>
                <PODiscrepancyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quality/complaints"
            element={
              <ProtectedRoute>
                <ComplaintsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <AnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bulk-upload"
            element={
              <ProtectedRoute>
                <BulkUploadPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/done-tasks"
            element={
              <ProtectedRoute>
                <DoneTasksReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/fulfillment-dashboard"
            element={
              <ProtectedRoute>
                <FulfillmentDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/pf-new"
            element={
              <ProtectedRoute>
                <ProductionFulfillmentNewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/pf-new"
            element={
              <ProtectedRoute>
                <PurchaseFulfillmentNewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/utilities/maintenance-mode"
            element={
              <ProtectedRoute>
                <MaintenanceModePage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" duration={3000} closeButton richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
